import { ResponseTotalCartAmountInfoModel } from './index';

export class ResponseCartSummaryModel {

  totalAmount: ResponseTotalCartAmountInfoModel;
  totalQuantity: number;
}
